import { useState } from 'react';

// import { routeTypes } from '../../../useSystemRoutes'
import { useUsers, userTypes } from '../../../api/useUsers'
import { useSystemPrompt } from '../../../useSystemPrompt';

import { documentTypes } from "../../../api/useDocuments"
import { validateRouteType } from './default';

import {
    useDependencies,
    targetTypes as dependencyTargetTypes,
    dependencyModules,
    dependencyRelations,
    dependencyRefs,
    formikDependencyStateField,
} from "../../../api/useDependencies"

export function useStateDeliveryTrip() {

    const { promptMessage } = useSystemPrompt()
    const { get } = useUsers({ userType: userTypes.customer })

    const { getDependencyItem } = useDependencies()

    // const validateRouteType = (val) => {
    //     if (
    //         val !== routeTypes.admin &&
    //         val !== routeTypes.workstation
    //     ) throw new Error(`Unsupported route : ${val}`)
    // }

    // const fetchBranches = async ({ userType, userId }) => {

    //     try {

    //         // if(userType === userTypes.customer){
    //         const { data } = await get({ id: userId, userType: userTypes.customer, dataTypesArray: ["branch", "shipping_address"] })

    //         // setDataBranches(data?.customer?.branches? data.customer.branches : [])
    //         // setDataShipping(data?.customer?.shipping_addresses? data.customer.shipping_addresses : [])
    //         // }

    //         // if(userType === userTypes.retail){
    //         //     const { data } = await getRetailer({ id: userId, userType: userTypes.retail, dataTypesArray: ["retail_outlet","shipping_address"] })

    //         //     setDataBranches(data?.retailer?.retail_outlets? data.retailer.retail_outlets : [])
    //         //     setDataShipping(data?.retailer?.shipping_addresses? data.retailer.shipping_addresses : [])
    //         // }

    //         return {
    //             billing: data?.customer?.branches ? data.customer.branches : [],
    //             shipping: data?.customer?.shipping_addresses ? data.customer.shipping_addresses : []
    //         }

    //     } catch (error) {
    //         promptMessage(false, `${error.message}`)
    //     }

    //     return {}

    // }

    const updateFormikStates = async ({
        data,
        routeType,
        setFieldValue,
    }) => {

        // validateRouteType(routeType);
        validateRouteType(routeType, documentTypes.tripOrder)

        const {
            document,
            docs
        } = data

        // console.log('data', data)

        // only load these fields
        setFieldValue(`remark`, document?.doc_remark ? document.doc_remark : "")
        setFieldValue(`referenceNo`, document?.reference_no ? document.reference_no : "")

        // docs.forEach((e, index) => {
        //     setFieldValue(`rows.${index}.documentDocId`, e?.document_id)
        //     setFieldValue(`rows.${index}.description`, e?.doc_remark)
        // })

        // append dependancies into state
        let depStates = getDependencyItem({
            targetType: dependencyTargetTypes.document,
            dependencyModule: document?.type.toLowerCase(),
            dependencyRef: dependencyRefs.document,
            targetId: document?.id,
            relation: dependencyRelations.reference,
        })

        setFieldValue(formikDependencyStateField, [depStates]) // only need one dependency item
    }

    const getFormikDependencyStates = ({ values }) => {
        return {
            [`${formikDependencyStateField}`]: values[`${formikDependencyStateField}`]
        }
    }

    return {
        updateFormikStates,
        getFormikDependencyStates
    }

}